import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

// TODO: api 모듈 구조를 다시 한번 생각해 보는 것이..
// api index 하나 두고 ApiCore 함수 써서 만든 객체를 export 하는 편이 더 나을듯
const STApi = ApiCore(globalDomains.ST_AFREECATV);
export default STApi;
